module.exports = __webpack_public_path__ + "img/art_6_5.5712d64a.png";